import type { FC, PropsWithChildren } from 'react';

import { Container } from '@zen/DesignSystem';

interface Props {
  title?: string;
}

const FormSection: FC<PropsWithChildren<Props>> = ({ children, title }) => {
  return (
    <div className="grid grid-cols-8 gap-8 xl:gap-6 xl:grid-cols-12 gap-y-0">
      <Container className="col-span-8" compactView={true} title={title}>
        <div className="p-6">{children}</div>
      </Container>
    </div>
  );
};

export default FormSection;
